import { useEffect } from "react";
import $ from "jquery";

import { OurProductsRangeList } from "./OurProductsRange.constant";

import "./OurProductsRange.scss";

const OurProductsRange = () => {
  useEffect(() => {}, []);
  return (
    <div id="our-products-range">
      <section className="app-weExpertise" id="we-expertise">
        <div className="app-weExpertise-container">
          <h2 className="app-weExpertise__headText">Our Products Range</h2>
          <div className="sce spot pspace s-tabs">
            <article>
              <div id="accordion" className="tabs">
                {OurProductsRangeList.map((productList, expertiseIndex) => (
                  <span key={`OurProductsRangeAccordion-${expertiseIndex}`}>
                    <span
                      id={`tab-${expertiseIndex}`}
                      className="tab-switch"
                    ></span>
                    <span className="tab-link accordion-toggle t-tag t-btop">
                      <span className="t-flx">
                        <div className="imgh">
                          <img
                            src={productList.imgURL}
                            alt={productList.label}
                            width="30"
                            height="30"
                          />
                        </div>
                        <p style={{ margin: 0, fontWeight: 500 }}>
                          {productList.label}
                        </p>
                      </span>
                    </span>
                    <div className="tab-content accordion-content is-hidden">
                      <h2>{productList.label}</h2>
                      <div className="tap-item">
                        {productList?.productItems.map(
                          (productItem, productItemIndex) => {
                            return (
                              <div
                                className="t-im-cnt"
                                key={`tap-item-${productItemIndex}`}
                              >
                                <div>
                                  <img
                                    className="fix-height"
                                    src={productItem.imgURL}
                                    alt={productItem.label}
                                    width="180"
                                    height="150"
                                  />
                                </div>
                                <p>{productItem.label}</p>
                              </div>
                            );
                          }
                        )}
                      </div>
                    </div>
                  </span>
                ))}
              </div>
            </article>
          </div>
        </div>
      </section>
    </div>
  );
};

$(document).ready(function ($) {
  $("#accordion")
    .find(".accordion-toggle")
    .click(function () {
      // modified from union deisgn+code at http://uniondesign.ca/simple-accordion-without-jquery-ui/
      // mc 4/2/2015
      //Expand or collapse this panel
      var isActive = $(this).hasClass("active");
      $(".accordion-toggle").removeClass("active");
      if (!isActive) {
        $(this).toggleClass("active");
      }

      $(this).next().slideToggle("fast");
      //Hide the other panels
      $(".accordion-content").not($(this).next()).slideUp("fast");
    });
});

export default OurProductsRange;
